import Actions from '../../odata/actions';

const actions = new Actions('purchaseLimit', 'purchaseLimits');

export default actions;
